<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="min-height: 80%">
      <header class="modal-card-head">
        <p class="modal-card-title">Card Financial #{{ financial.id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="panel" v-if="(!financial.service_extend_card && financial.main_card_id) || (financial.service_extend_card && !financial.vc_id && financial.service_extend_card.vc_status !== 'ACTIVE')">
          <p class="panel-heading">
            Cartão Others Ativo
          </p>
          <p class="panel-block">
            <b>Main Card: </b> {{ financial.card.brand }} - {{ financial.card.card }} - {{ financial.card.bank }}
          </p>
          <p class="panel-block">
            <b>Virtual Card: </b> {{ financial.vc_brand }} - {{ financial.vc_last4 }} - {{ financial.vc_holder }}
          </p>
        </div>
        <div class="control is-grouped" v-if="!financial.service_extend_card || (financial.service_extend_card && financial.service_extend_card.vc_status === 'CANCELLED') || (financial.service_extend_card && financial.service_extend_card.vc_status === 'EXPIRED')">
          <p class="control" style="min-width: 100%;">
            <label class="label">Choose Card Type</label>
            <select class="select is-fullwidth" v-model="card_type" name="card_type" id="card_type" >
              <option value="0">Select Card Type</option>
              <option v-if="parseInt(context.$store.state.config.user.extend_card) === 1" value="1">Extend</option>
              <option value="2">Clara</option>
              <option value="3">Others</option>
            </select>
          </p>
        </div>
        <!--################# CARD EXTEND #################-->
        <div class="control is-grouped" v-if="(card_type == 1) || (financial.service_extend_card && financial.service_extend_card.vc_status === 'ACTIVE')">
          <p class="control is-expanded" v-if="(!financial.service_extend_card) || (financial.service_extend_card && financial.service_extend_card.vc_status === 'CANCELLED') || (financial.service_extend_card && financial.service_extend_card.vc_status === 'EXPIRED')" style="min-width: 450px;">
            <label class="label">Extend Main Card</label>
            <v-select
              :options="parseCards(cards)"
              placeholder="Select Extend Main Card"
              label="name"
              v-model="cardMain"
              >
            </v-select>
            <span class="help is-danger">{{ cardErrors.cardMain }}</span>
          </p>
          <!--################# UPDATE / CANCEL EXTEND CARD #################-->
          <div class="control is-expanded" v-if="financial.service_extend_card && financial.service_extend_card.vc_status === 'ACTIVE'">
            <div class="panel">
              <p class="panel-heading">
                Cartão Extend
                <span>({{ financial.service_extend_card.vc_status }})</span>
              </p>
              <p class="panel-block">
                <b>Main Card: </b> {{ financial.card.brand }} - {{ financial.card.card }} - {{ financial.card.bank }}
              </p>
              <p class="panel-block">
                <b>Virtual Card: </b> {{ financial.vc_brand }} - {{ financial.vc_last4 }} - {{ financial.vc_holder }}
                <span v-if="financial.service_extend_card && financial.service_extend_card.vc_status === 'CANCELLED' && financial.card.vc_card_id === financial.service_extend_card.vc_card_id"><b>(CANCELLED)</b></span>
                <span v-if="financial.service_extend_card && financial.service_extend_card.tx_status === 'CLEARED' && financial.card.vc_card_id === financial.service_extend_card.vc_card_id"><b>(CLEARED)</b></span>
                <span v-if="financial.service_extend_card && financial.service_extend_card.tx_status === 'PENDING' && financial.card.vc_card_id === financial.service_extend_card.vc_card_id"><b>(PENDING)</b></span>
                <span v-if="financial.service_extend_card && financial.service_extend_card.vc_status === 'EXPIRED' && financial.card.vc_card_id === financial.service_extend_card.vc_card_id"><b>(EXPIRED)</b></span>
              </p>
            </div>
            <div v-if="financial.service_extend_card &&
                      financial.service_extend_card.vc_status === 'ACTIVE' &&
                      financial.service_extend_card.tx_status !== 'PENDING' &&
                      financial.service_extend_card.tx_status !== 'CLEARED'">
              <p class="control" style="min-width: 100%;">
                <label class="label">Extend Card Active</label>
                <select class="select is-fullwidth" v-model="update_cancel_extend_card" name="update_cancel_extend_card" id="update_cancel_extend_card" >
                  <option value="0">Select Action</option>
                  <option value="1">Update Card</option>
                  <option value="2">Cancel Card</option>
                </select>
              </p>
              <p class="control" v-if="update_cancel_extend_card == 1">
                <label class="label">New Balance</label>
                <input class="input" type="number" name="new_balance" id="new_balance" v-model="new_balance">
                <span class="help is-danger">{{ cardErrors.new_balance }}</span>
              </p>
            </div>
          </div>
        </div>
        <!--################# CARD CLARA #################-->
        <div class="control is-grouped" v-if="(card_type == 2) || (financial.service_clara_card && financial.service_clara_card.vc_card_status === 'ACTIVE')">
          <!--################# UPDATE / CANCEL CLARA CARD #################-->
          <div class="control is-expanded" v-if="financial.service_clara_card && financial.service_clara_card.vc_status === 'ACTIVE'">
            <div v-if="financial.service_clara_card &&
                      financial.service_clara_card.vc_status === 'ACTIVE' &&
                      financial.service_extend_card.vc_status !== 'LOCKED' &&
                      financial.service_extend_card.vc_status !== 'AUTHORIZED'">
              <p class="control" v-if="update_cancel_extend_card == 1">
                <label class="label">New Balance</label>
                <input class="input" type="number" name="new_balance" id="new_balance" v-model="new_balance">
                <span class="help is-danger">{{ cardErrors.new_balance }}</span>
              </p>
            </div>
          </div>
        </div>
        <!--################# CARD OTHERS #################-->
        <div v-if="card_type === '3'">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Card</label>
              <input :class="{'input': true, 'is-danger': (cardErrors.cardNumber !== '')}" v-cardformat:formatCardNumber v-model="cardNumber">
              <span class="help is-danger">{{ cardErrors.cardNumber }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Holder</label>
              <input :class="{'input': true, 'is-danger': (cardErrors.cardHolder !== '')}" v-model="cardHolder">
              <span class="help is-danger">{{ cardErrors.cardHolder }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Expiry</label>
              <input :class="{'input': true, 'is-danger': (cardErrors.cardExpiry !== '')}" v-cardformat:formatCardExpiry v-model="cardExpiry">
              <span class="help is-danger">{{ cardErrors.cardExpiry }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">CVC</label>
              <input :class="{'input': true, 'is-danger': (cardErrors.cardCVC !== '')}" v-cardformat:formatCardCVC v-model="cardCvc">
              <span class="help is-danger">{{ cardErrors.cardCVC }}</span>
            </p>
          </div>
          <div class="control is-grouped">
            <p class="control" style="min-width: 100%;">
              <label class="label">Main Card</label>
              <v-select
                :options="parseCards(cards)"
                placeholder="Select Main Card"
                label="name"
                v-model="cardMain"
                >
              </v-select>
              <span class="help is-danger">{{ cardErrors.cardMain }}</span>
            </p>
          </div>
        </div>
        <!--OPÇÕES DE AÇÃO, COMENTARIOS, EMAIL E LINGUA-->
        <div class="control is-grouped" v-if="(card_type != 0 && !financial.service_extend_card) || (card_type != 0 && financial.service_extend_card && financial.service_extend_card.vc_status !== 'ACTIVE')">
          <p class="control is-expanded">
            <label class="label">Save Action</label>
            <v-select
              :options="parseSaveButton()"
              name="saveButton"
              placeholder="Choose action"
              label="name"
              v-model="saveButton">
            </v-select>
          </p>
        </div>
        <!--APENAS SE SAVE BUTTON FOR SEND AND SAVE CARD-->
        <div v-if="saveButton.id === 2">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Hotel Email</label>
              <input
                :class="{'input': true, 'is-danger': (emailErrors.hotelEmail !== '')}"
                type="email" name="email" id="email"
                placeholder="exemple@email.com"
                v-model="hotelEmail"
                v-validate="'required|email'">
              <span class="help is-danger">{{ emailErrors.hotelEmail }}</span>
              <span v-show="errors.has('email')" class="help is-danger">Email invalido</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Email Language</label>
              <v-select
                :options="parseLanguage()"
                placeholder="Select Language"
                label="name"
                v-model="emailLanguage">
              </v-select>
              <span class="help is-danger">{{ emailErrors.emailLanguage }}</span>
            </p>
          </div>
          <div>
            <p class="control is-expanded">
              <label class="label">Booking info</label>
              <textarea
                :class="{'input': true, 'is-danger': (emailErrors.emailInfo !== '')}"
                type="textarea" name="text" id="text"
                placeholder="As informações colocadas nesse campo serão incorporadas ao anexo enviado por email, na parte de descrição. Você pode colocar dados relevantes como: Numero do identificador do hotel, descrição do serviço que está sendo pago... (atenção para escrever no idioma selecionado acima)"
                v-model="emailInfo"
                v-validate="'required|min:10'"
                style="height: 150px;">
              </textarea>
              <span class="help is-danger">{{ emailErrors.emailInfo }}</span>
              <span v-show="errors.has('text')" class="help is-danger">Obrigatório informar um texto com mais de 10 caracteres</span>
            </p>
          </div>
        </div>
        <!--APENAS SE SAVE BUTTON FOR SEND AND SAVE CARD (2)-->
        <!--OPÇÕES DE AÇÃO, COMENTARIOS, EMAIL E LINGUA-->
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a
              :class="{'button': true, 'is-success': true, 'is-disabled': cardErrors === '' || inProgress, 'is-loading': inProgress}"
              @click="saveCard(false)"
              v-if="saveButton.id === 1">Save Card
            </a>
            <a
              :class="{'button': true, 'is-success': true, 'is-disabled': cardErrors === '' || emailErrors === '' || inProgress, 'is-loading': inProgress}"
              @click="saveCard(false)"
              v-if="saveButton.id === 2">Send and Save Card
            </a>
            <a
              :class="{'button': true, 'is-info': true, 'is-disabled': new_balance < 0.1 || inProgress, 'is-loading': inProgress}"
              @click="updateCard()"
              v-if="update_cancel_extend_card == 1">Update Card
            </a>
            <a
              :class="{'button': true, 'is-info': true || inProgress, 'is-loading': inProgress}"
              @click="cancelCard(true)"
              v-if="update_cancel_extend_card == 2">Cancel Card
            </a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      financial: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        cardNumber: '',
        cardHolder: '',
        cardCvc: '',
        cardExpiry: '',
        cardBrand: '',
        cardMain: '',
        cardError: '',
        cardErrors: {
          cardNumber: '',
          cardExpiry: '',
          cardCVC: '',
          cardHolder: '',
          cardMain: '',
          new_balance: ''
        },
        saveButton: '',
        hotelEmail: '',
        emailLanguage: '',
        emailInfo: '',
        emailError: '',
        emailErrors: {
          hotelEmail: '',
          emailLanguage: '',
          emailInfo: ''
        },
        new_balance: 0,
        card_type: 0,
        update_cancel_extend_card: 0,
        cards: [],
        inProgress: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadCards()
      })
    },
    methods: {
      loadCards () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/finances/cardsMain').then((response) => {
          this.cards = response.body
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      parseCards (data) {
        let cards = []
        let brand = ''
        for (var i = 0; i < data.length; i++) {
          switch (data[i].brand) {
            case 'AMERICAN-EXPRESS':
              brand = 'AX'
              break
            case 'VISA':
              brand = 'VI'
              break
            case 'MASTERCARD':
              brand = 'MC'
              break
          }
          if (this.cards[i].vc_card_id !== null && this.card_type === '1' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          } else if (this.cards[i].vc_card_id === null && this.card_type === '2' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          } else if (this.card_type === '3' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          }
        }
        return cards
      },
      parseLanguage () {
        let languages = [
          {
            id: 1,
            name: 'Portuguese'
          },
          {
            id: 2,
            name: 'Spanish'
          },
          {
            id: 3,
            name: 'English'
          }
        ]

        return languages
      },
      parseSaveButton () {
        let saveButton = [
          {
            id: 1,
            name: 'Save Card'
          },
          {
            id: 2,
            name: 'Send and Save Card'
          }
        ]

        return saveButton
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      saveCard (sendEmail) {
        if (window.confirm('Are you sure you want to CREATE a new card?')) {
          this.cardErrors.cardNumber = ''
          this.cardErrors.cardHolder = ''
          this.cardErrors.cardExpiry = ''
          this.cardErrors.cardCVC = ''
          this.cardErrors.cardMain = ''
          this.cardError = false
          this.emailErrors.hotelEmail = ''
          this.emailErrors.emailLanguage = ''
          this.emailErrors.emailInfo = ''
          this.emailError = false
          // Extend cards
          if (this.card_type === '1') {
            if (!this.cardMain) {
              this.cardErrors.cardMain = 'Invalid Main Card.'
              this.cardError = true
            } else {
              this.cardErrors.cardMain = ''
            }
            if (this.saveButton.id === 2) {
              this.emailDataValidation()
            }
            if (!this.cardError && !this.emailError) {
              let data = null
              if (this.saveButton.id === 2) {
                data = {
                  cardMain: this.cardMain.value,
                  sendEmail: true,
                  email: this.hotelEmail,
                  emailLanguage: this.emailLanguage.id,
                  emailInfo: this.emailInfo,
                  direct: true
                }
              } else {
                data = {
                  cardMain: this.cardMain.value,
                  sendEmail: false,
                  direct: true
                }
              }
              this.context.$http.post(this.context.$store.state.config.apiURL + '/services/' + this.financial.id + '/card_extend', data).then((response) => {
                if (response.body === 'Error') {
                  this.close(true, 'ok')
                  this.message('danger', 'Error', 'The system was not able to create the card. Try again in a few seconds.')
                } else {
                  this.close(true, 'ok')
                  this.message('success', 'Success', 'The extend card has been successfully saved')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
          // Clara cards
          if (this.card_type === '2') {
            if (this.saveButton.id === 2) {
              this.emailDataValidation()
            }
            if (!this.emailError) {
              let data = this.saveButton.id === 2
                ? {
                  cardMain: 15721,
                  direct: true,
                  sendEmail: true,
                  email: this.hotelEmail,
                  emailLanguage: this.emailLanguage.id,
                  emailInfo: this.emailInfo
                }
                : {
                  cardMain: 15721,
                  direct: true
                }
              this.context.$http.post(
                this.context.$store.state.config.apiURL + '/services/' + this.financial.id + '/card_clara',
                data
              ).then((response) => {
                if (response.body !== 'ok') {
                  this.close(true, 'ok')
                  this.message('warning', 'Warning', response.body, 30000)
                } else {
                  this.close(true, 'ok')
                  this.message('success', 'Success', 'The card has been successfully saved')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.close(true, 'ok')
                this.message('danger', 'Error', response.body)
              })
            }
          }
          // Others card
          if (this.card_type === '3') {
            // validate card number
            if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
              this.cardErrors.cardNumber = 'Invalid Credit Card Number.'
              this.cardError = true
            } else {
              this.cardErrors.cardNumber = ''
            }
            if (this.cardHolder.trim() === '') {
              this.cardErrors.cardHolder = 'Invalid Credit Card Holder.'
              this.cardError = true
            } else {
              this.cardErrors.cardHolder = ''
            }
            // validate card expiry
            if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
              this.cardErrors.cardExpiry = 'Invalid Expiration Date.'
              this.cardError = true
            } else {
              this.cardErrors.cardExpiry = ''
            }
            // validate card CVC
            if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
              this.cardErrors.cardCVC = 'Invalid CVC.'
              this.cardError = true
            } else {
              this.cardErrors.cardCVC = ''
            }
            if (!this.cardMain) {
              this.cardErrors.cardMain = 'Invalid Main Card.'
              this.cardError = true
            } else {
              this.cardErrors.cardMain = ''
            }
            // VALIDAR DADOS EMAIL
            if (this.saveButton.id === 2) {
              this.emailDataValidation()
            }
            if (!this.cardError && !this.emailError) {
              let data = null
              if (this.saveButton.id === 2) {
                data = {
                  cardNumber: this.cardNumber,
                  cardHolder: this.cardHolder,
                  cardCvc: this.cardCvc,
                  cardExpiry: this.cardExpiry,
                  cardBrand: this.cardBrand,
                  cardMain: this.cardMain.value,
                  sendEmail: true,
                  email: this.hotelEmail,
                  emailLanguage: this.emailLanguage.id,
                  emailInfo: this.emailInfo,
                  direct: true
                }
              } else {
                data = {
                  cardNumber: this.cardNumber,
                  cardHolder: this.cardHolder,
                  cardCvc: this.cardCvc,
                  cardExpiry: this.cardExpiry,
                  cardBrand: this.cardBrand,
                  cardMain: this.cardMain.value,
                  direct: true
                }
              }
              this.context.$http.post(this.context.$store.state.config.apiURL + '/services/' + this.financial.id + '/card', data).then((response) => {
                if (response.body !== 'ok') {
                  this.close(true, 'ok')
                  this.message('warning', 'Warning', response.body, 30000)
                } else {
                  this.close(true, 'ok')
                  this.message('success', 'Success', 'The card has been successfully saved')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.close(true, 'ok')
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      updateCard () {
        if (window.confirm('Are you sure you want to UPDATE this Virtual Card?')) {
          this.cardError = false
          if (this.update_cancel_extend_card === '1') {
            this.cardErrors.new_balance = ''
            if (this.new_balance < 0.1) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else {
              this.cardErrors.new_balance = ''
            }
            if (!this.cardError) {
              let data = null
              data = {
                vc_id: this.financial.vc_id,
                new_balance: this.new_balance,
                direct: true
              }
              this.context.$http.post(this.context.$store.state.config.apiURL + '/services/' + this.financial.id + '/update_card_extend', data).then((response) => {
                if (response.body === 'Error') {
                  this.close(true, 'ok')
                  this.message('danger', 'Error', 'The system was not able to update the card. Try again in a few seconds.')
                } else {
                  this.close(true, 'ok')
                  this.message('success', 'Success', 'The extend card has been successfully updated.')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.close(true, 'ok')
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      cancelCard () {
        if (window.confirm('Are you sure you want to CANCEL this Virtual Card?')) {
          let data = null
          data = {
            vc_id: this.financial.vc_id,
            direct: true
          }
          this.context.$http.post(this.context.$store.state.config.apiURL + '/services/' + this.financial.id + '/cancel_card_extend', data).then((response) => {
            if (response.body === 'Error') {
              this.message('danger', 'Error', 'The system was not able to cancel the card. Try again in a few seconds.')
            } else {
              this.message('success', 'Success', 'The extend card has been successfully cancelled')
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            }
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      },
      emailDataValidation () {
        // VALIDAR DADOS EMAIL
        if (!this.hotelEmail) {
          this.emailErrors.hotelEmail = 'Informe um email valido.'
          this.emailError = true
        }
        if (!this.emailLanguage) {
          this.emailErrors.emailLanguage = 'Informe um idioma.'
          this.emailError = true
        }
        if (!this.emailInfo) {
          this.emailErrors.emailInfo = 'Informe a descrição do serviço.'
          this.emailError = true
        }
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      vSelect
    }
  }
</script>

<style scoped>
.panel-heading {
  color: #FFFFFF;
  font-weight: bold;
  -ms-flex-align: stretch;
  align-items: stretch;
  display: -ms-flexbox;
  display: flex;
  min-height: 40px;
  box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
  background-color: rgb(167, 28, 32);
  border-bottom: 0px;
  border-radius: 0px;
  font-size: 1rem;
}

.panel {
  background-color: white;
  box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
  border: 0px;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// CardFinancial.vue?69fdfcba